import { render, staticRenderFns } from "./MapCompanyLocationCard.vue?vue&type=template&id=1afeedbe"
import script from "./MapCompanyLocationCard.vue?vue&type=script&lang=js"
export * from "./MapCompanyLocationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports